/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.meetings.rpc.BookingFailureRpc
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

/**
 *  This is a duplicate of com.hubspot.meetings.base.booking.UtmIF because UtmIF is used in a CHIRP RPC, which requires all models to be in a MODEL module. The existing UtmIF is in a CORE module type and can't be easily moved because of external usages.
 */

export const publishRequestRpc = {
  serviceName: 'com.hubspot.meetings.rpc.BookingFailureRpc',
  rpcName: 'publishRequest',
  auth: 'app',
  fingerprint: 'LySdujrTTqyOUe2e_r4XmXutmxUV8CQD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getOfflineBookingInfoRpc = {
  serviceName: 'com.hubspot.meetings.rpc.BookingFailureRpc',
  rpcName: 'getOfflineBookingInfo',
  auth: 'app',
  fingerprint: '6fGdUBnatDScAKamTwIrdnutmxUV8CQD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};